module.exports = __webpack_public_path__ + "img/fig10.436e2939.jpg";